import React from "react";
import { getFlujoAsesor } from "../../hyperFlow/hyperFlowApi";
import ClipLoader from "react-spinners/ClipLoader";

export interface ServiceSelectComponentProps {
  title: string;
  description?: string;
  buttonText?: string;
  hyperFlowId: string;
  idAsesor: string;
  primaryTextColor: string;
  buttonColor: string;
  buttonTextColor: string;
}
export const ServiceSelectComponent = (props: ServiceSelectComponentProps) => {
  const [loading, setLoading] = React.useState(false);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        margin: "12px 0px 12px 0px",
      }}
    >
      <h5
        style={{
          textAlign: "start",
          fontSize: "16px",
          fontWeight: 600,
          color: props.primaryTextColor,
          margin: "10px 0px 10px 0px",
        }}
      >
        {props.title}
      </h5>
      {props.description && (
        <p
          style={{
            textAlign: "start",
            fontSize: "14px",
            color: props.primaryTextColor,
            fontWeight: 400,
          }}
        >
          {props.description}
        </p>
      )}
      <button
        onClick={async () => {
          setLoading(true);
          await getFlujoAsesor(props.idAsesor, props.hyperFlowId);
          setLoading(false);
        }}
        style={{
          backgroundColor: props.buttonColor,
          color: props.buttonTextColor,
          border: "none",
          borderRadius: "30px",
          padding: "8px",
          textAlign: "center",
          fontSize: "15px",
          fontWeight: 600,
          marginTop: "10px",
          cursor: "pointer",
        }}
      >
        {" "}
        {loading ? (
          <ClipLoader color={props.primaryTextColor} size={20} />
        ) : (
          props.buttonText || "Empezar Aquí"
        )}
      </button>
    </div>
  );
};
